import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";

export default function Calls() {
  const [calls, setCalls] = useState([]);

  const fetchCalls = async () => {
    const snap = await getDocs(collection(db, "calls"));
    setCalls(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
  };

  useEffect(() => { fetchCalls(); }, []);

  return (
    <div>
      <h1>📞 Calls</h1>
      <div className="card">
        <table width="100%">
          <thead>
            <tr>
              <th>Astrologer</th><th>User</th><th>Type</th><th>Status</th><th>Start</th>
            </tr>
          </thead>
          <tbody>
            {calls.map((c) => (
              <tr key={c.id}>
                <td>{c.astroId}</td>
                <td>{c.userId}</td>
                <td>{c.callType}</td>
                <td>{c.status}</td>
                <td>{c.createdAt ? new Date(c.createdAt.seconds * 1000).toLocaleString() : "N/A"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}